export default __webpack_public_path__ + "static/media/edunette.b87b3995.webp";